import React from "react";
import { Redirect } from "react-router-dom";
import { Content, Footer, Header, Sidebar } from "../Layout";
import * as GeneralFunctions from "../../GeneralFunctions";
import HostList from "../../hostName.json";
export const GlobalContext = React.createContext("");

function ScrollToTop(props) {
  window.scrollTo(0, 0);
  return props.children;
}

class MainLayout extends React.Component {
  constructor(props) {
    super(props);
    let limit = GeneralFunctions.getPageLimit() || 100;
    this.shopToken = null;
    this.state = {
      limit: limit,
      updateState: this.updateState,
    };
  }

  updateState = async (obj) => {
    if (obj.limit) GeneralFunctions.setPageLimit(obj.limit);
    this.setState(obj);
  };

  static isSidebarOpen() {
    return document
      .querySelector(".cr-sidebar")
      .classList.contains("cr-sidebar--open");
  }

  componentWillReceiveProps({ breakpoint }) {
    if (breakpoint !== this.props.breakpoint) {
      this.checkBreakpoint(breakpoint);
    }
  }

  componentDidMount() {
    if (this.shopToken) {
      this.checkBreakpoint(this.props.breakpoint);
    }
  }

  // close sidebar when
  handleContentClick = (event) => {
    // close sidebar if sidebar is open and screen size is less than `md`
    if (
      MainLayout.isSidebarOpen() &&
      (this.props.breakpoint === "xs" ||
        this.props.breakpoint === "sm" ||
        this.props.breakpoint === "md")
    ) {
      this.openSidebar("close");
    }
  };

  checkBreakpoint(breakpoint) {
    switch (breakpoint) {
      case "xs":
      case "sm":
      case "md":
        return this.openSidebar("close");

      case "lg":
      case "xl":
      default:
        return this.openSidebar("open");
    }
  }

  openSidebar(openOrClose) {
    if (openOrClose === "open") {
      return document
        .querySelector(".cr-sidebar")
        .classList.add("cr-sidebar--open");
    }
    document.querySelector(".cr-sidebar").classList.remove("cr-sidebar--open");
  }

  render() {
    let host = window.location.host;
    this.shopToken = GeneralFunctions.getAuthorizationHeader();
    const { children } = this.props;
    let hostExist = HostList.find((hostName) => hostName === host);
    return !this.shopToken ? (
      hostExist ? (
        <Redirect to="/admin/login"></Redirect>
      ) : (
        <Redirect to="/login"></Redirect>
      )
    ) : (
      <main className="cr-app bg-light">
        <Sidebar />
        <Content fluid onClick={this.handleContentClick}>
          <Header />
          <ScrollToTop props={this.props}>
            <GlobalContext.Provider value={this.state}>
              {children}
            </GlobalContext.Provider>
          </ScrollToTop>
          <Footer />
        </Content>
      </main>
    );
  }
}

export default MainLayout;
